import React from 'react';
import './App.css';
import Hero from './components/Hero';
import OurStory from './components/OurStory';
import Gallery from './components/Gallery';
import EventDetails from './components/EventDetails';
// import Schedule from './components/Schedule'; // Hidden for now
import Travel from './components/Travel';
import FAQ from './components/FAQ';
import RSVP from './components/RSVP';
import Navigation from './components/Navigation';
import Countdown from './components/Countdown';

function App() {
  return (
    <div className="min-h-screen bg-wedding-cream">
      <Navigation />
      <Hero />
      <Countdown />
      <OurStory />
      <EventDetails />
      {/* <Schedule /> */}
      <Gallery />
      <Travel />
<FAQ />
      <RSVP />

      <footer className="bg-wedding-navy text-white py-8 text-center">
        <p className="font-serif text-2xl mb-2">Nelisa & Jesse</p>
        <p className="text-sm mb-4">June 26, 2027 • Punta Cana, Dominican Republic</p>
        <p className="text-xs text-gray-300">
          <a href="/privacy-policy.html" className="hover:text-wedding-gold transition-colors">
            Privacy Policy
          </a>
          <span className="mx-2">·</span>
          <a href="/terms.html" className="hover:text-wedding-gold transition-colors">
            Terms &amp; Conditions
          </a>
        </p>
      </footer>
    </div>
  );
}

export default App;
